import actions from "./actions";

const {
    FETCH_STUDENT_CLUB_MEMBERSHIP,
    FETCH_STUDENT_CLUB_MEMBERSHIPS,
    RESET_STUDENT_CLUB_MEMBERSHIP
} = actions;

const initState = {
    memberships: {
        page: 1,
        perPage: 10,
        data: [],
        total: 0
    },
    membership: {
        _id: null,
        student: null,     // Student Snapshot {_id, firstName, lastName, studentId, photo}
        session: null,     // Session Snapshot {_id, startYear, endYear, isCurrent}
        class: null,       // Class Snapshot {_id, name}
        mainClub: null,    // Main Club Reference ID / Populated Object
        subClubs: [],      // Array of Sub-Club Snapshots [{_id, name, code}]
        status: "active",
        enrolledAt: null,
        createdBy: null,
        updatedBy: null
    }
};

const StudentClubMembershipReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_STUDENT_CLUB_MEMBERSHIPS:
            return {
                ...state,
                memberships: {
                    page: data?.page || initState.memberships.page,
                    perPage: data?.perPage || initState.memberships.perPage,
                    total: data?.total || 0,
                    data: Array.isArray(data?.data) ? [...data.data] : []
                }
            };

        case RESET_STUDENT_CLUB_MEMBERSHIP:
            return {
                ...state,
                membership: {
                    ...initState.membership,
                    subClubs: []
                }
            };

        case FETCH_STUDENT_CLUB_MEMBERSHIP:
            return {
                ...state,
                membership: {
                    ...initState.membership,
                    ...data,
                    student: data?.student ? { ...data.student } : null,
                    session: data?.session ? { ...data.session } : null,
                    class: data?.class ? { ...data.class } : null,
                    subClubs: Array.isArray(data?.subClubs) ? [...data.subClubs] : []
                }
            };

        default:
            return state;
    }
};

export default StudentClubMembershipReducer;